module.exports = __webpack_public_path__ + "static/img/合照5.2a098a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/hezhao/合照5.jpg
// module id = NrLi
// module chunks = 1